import { MaskedInput } from 'components/Inputs/MaskedInput';
import { SelectInput } from 'components/Inputs/SelectInput';
import { SwitchDoubleValue } from 'components/Inputs/SwitchDoubleValue';
import { TextInput } from 'components/Inputs/TextInput';
import { uf } from 'mocks';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { IRepresentant } from 'types/Representant';

import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LanguageIcon from '@mui/icons-material/Language';
import {
  Checkbox,
  Grid,
  InputAdornment,
  ListItemText,
  MenuItem,
  Stack,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';

import { RepresentativeAddressForm } from './AddressForm';

export const RepresentativeForm: React.FC = () => {
  return (
    <Box p={2}>
      <Stack
        spacing={2}
        direction="row"
        alignItems="flex-start"
        justifyContent="space-between"
      >
        <Typography sx={{ fontSize: 20, fontWeight: 500 }}>
          DADOS CADASTRAIS
        </Typography>

        <SwitchDoubleValue
          name="active"
          id="active"
          leftlabel="Inativo"
          leftValue={false}
          rightLabel="Ativo"
          rightValue={true}
        />
      </Stack>

      <Grid item container spacing={2} mt={1}>
        <Grid item xs={12} md={6}>
          <TextInput
            name="socialReason"
            id="socialReason"
            label="RAZÃO SOCIAL"
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextInput
            name="tradingName"
            id="tradingName"
            label="NOME FANTASIA"
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <MaskedInput
            name="cnpj"
            id="cnpj"
            label="CNPJ"
            placeholder="__.___.___/____-__"
            mask="##.###.###/####-##"
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <MaskedInput
            name="cpf"
            id="cpf"
            label="CPF"
            placeholder="___.___.___-__"
            mask="###.###.###-##"
            required={true}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextInput name="name" id="name" label="NOME" required={true} />
        </Grid>

        <Grid item xs={12} md={3}>
          <MaskedInput
            name="phone"
            id="phone"
            label="TELEFONE FIXO"
            mask="(##) ####-####"
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <MaskedInput
            name="mobilePhone"
            id="mobilePhone"
            label="TELEFONE CELULAR"
            mask="(##) #####-####"
            required={true}
          />
        </Grid>

        <RepresentativeAddressForm />

        <Grid item xs={12} md={6}>
          <TextInput
            fullWidth
            id="email"
            name="email"
            label="E-MAIL"
            required={true}
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <WorkingStateInput />
        </Grid>

        <Grid item xs={12} md={3}>
          <TextInput
            name="site"
            id="site"
            label="SITE"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <LanguageIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <TextInput
            name="instagram"
            id="instagram"
            label="INSTAGRAM"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <InstagramIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <TextInput
            name="facebook"
            id="facebook"
            label="FACEBOOK"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <FacebookIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

const WorkingStateInput: React.FC = () => {
  const { control } = useFormContext<IRepresentant>();
  const workingState = useWatch({ control, name: 'workingState' });

  return (
    <SelectInput
      name="workingState"
      id="workingState"
      label="ESTADO DE ATUAÇÃO"
      required={true}
      multiple
      renderValue={(selected: any) => selected.join(', ')}
    >
      {Object.entries(uf).map(([value, name]) => (
        <MenuItem key={value} value={value}>
          <Checkbox checked={workingState?.includes(name)} />
          <ListItemText primary={name} />
        </MenuItem>
      ))}
    </SelectInput>
  );
};
